import React from 'react';
import styled from '@emotion/styled';
import { Box, Container, Grid, IconButton, Snackbar, Alert, useMediaQuery } from '@mui/material';
import { FiCopy } from 'react-icons/fi';
import logo from '../../../assets/logo.svg';
import tgfooter from '../../../assets/tgfooter.svg';
import xfooter from '../../../assets/xfooter.svg';
import copy from '../../../assets/Copy.svg';
import Paragraph from '../../Components/LockerMenu/component/Paragraph';
import { Coingecko, CoinMarketCap, dexScreenerLink, PhysicalProductsStore, PrivacyPolicy, TermsofUse, uniSwapLink, VirtualProductsStore, VirtualServicesStore } from '../../../links';

const Wrapper = styled(Box)`
  padding: 80px 0px;
`;

const AddressContainer = styled(Box)`
  display: flex;
  align-items: center;
  border: 2px solid #d5ecff;
  color: #030930;
  padding: 12px 14px;
  width: 100%;
  max-width: 460px;
  border-radius: 14px;
  gap: 8px;
  font-size: 15px;

  @media (max-width: 600px) {
    top: 20px;
   left: 140px;
  flex-direction: row;
  justify-content: center;
 font-size: 12px;
 padding: 6px 10px;
  }
`;

const Secdiv = styled('div')`
margin-bottom: 80px;
  @media (max-width: 899px) {
    flex-direction: column;
  }
`;

const Firstdiv = styled('div')`
  @media (max-width: 899px) {
    justify-content: center;
    text-align: center;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
`;

const Mainimg = styled('img')`
  width: 100%;
  max-width: 200px;
  height: auto;
  @media (max-width: 899px) {
    margin-bottom: 20px;
  }
`;

const StyledParagraph = styled(Paragraph)`
  margin-bottom: 10px;
  cursor: pointer;

  @media (max-width: 600px) {
    margin-bottom: 10px;
  }
`;

const MainParagraph = styled(Paragraph)`

    @media (max-width: 600px) {
    margin-bottom: 50px;
  }
`

const Thirddiv = styled('div')`
   @media (max-width: 600px) {
    flex-direction: column;
  } 
`
const Innerdiv = styled('div')`
 @media (max-width: 600px) {
    flex-direction: column;
    margin-top: 10px;
    margin-bottom: 10px;
    gap: 10px !important;
  } 
`

const Footer = () => {
  const contractAddress = '0x87904bE82BC1C29E94a0b99474d183B4e08a7E47';
  const [open, setOpen] = React.useState(false);
  const isMobile = useMediaQuery('(max-width:600px)');

  const copyToClipboard = () => {
    navigator.clipboard.writeText(contractAddress);
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const displayAddress = isMobile 
    ? `${contractAddress.substring(0, 6)}...${contractAddress.substring(contractAddress.length - 7)}`
    : contractAddress;

  return (
    <Wrapper>
      <Container maxWidth="xl">
        <Grid container sx={{padding: { xs: '0px', md: '0px 20px' } }}>
          <Grid xs={12} md={12}>
            <Firstdiv style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '60px' }}>
              <Mainimg src={logo} alt="logo" draggable='false' />
              <AddressContainer>
                {displayAddress}
                <IconButton onClick={copyToClipboard} size="small" sx={{ padding: '4px', color: '#000' }}>
                  <img src={copy} alt="copy"  draggable='false'/>
                </IconButton>
              </AddressContainer>

              <Snackbar
                open={open}
                autoHideDuration={3000}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              >
                <Alert onClose={handleClose} severity="success" sx={{ width: '100%', backgroundColor: '#000' }}>
                  Address copied to clipboard!
                </Alert>
              </Snackbar>
            </Firstdiv>

            <Secdiv style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Grid xs={12} md={5.8}>
                <MainParagraph style={{ maxWidth: '600px',opacity: '0.6' }}>
                  AICM is an AI-driven e-commerce marketplace powered by blockchain. It connects crypto communities to
                  buy, sell, and list physical goods, digital products, and services, offering advanced AI tools and
                  secure transactions.
                </MainParagraph>
              </Grid>
              <Grid item xs={12} md={1.5} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <StyledParagraph style={{opacity: '0.6'}}>Who we are</StyledParagraph>
               <a href='#About'><StyledParagraph>About</StyledParagraph></a>
                <a href='https://aicm-store.gitbook.io/whitepaper' target='blank'><StyledParagraph>Whitepaper</StyledParagraph></a>
                {/* <MainParagraph>News & Media</MainParagraph> */}
              </Grid>
              <Grid item xs={12} md={2} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <StyledParagraph  style={{opacity: '0.6'}}>Product</StyledParagraph>
               <a href='https://app.aicm.store' target="_blank" rel="noopener noreferrer"><StyledParagraph>Physical Products Store</StyledParagraph></a>
                <a href='https://app.aicm.store' target="_blank" rel="noopener noreferrer"><StyledParagraph>Virtual Products Store</StyledParagraph></a>
                <a href='https://app.aicm.store' target="_blank" rel="noopener noreferrer"><MainParagraph>Virtual Services Store</MainParagraph></a>
              </Grid>
              <Grid item xs={12} md={1.5} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <StyledParagraph style={{opacity: '0.6'}}>Find us on</StyledParagraph>
              <a href={uniSwapLink}  target="_blank" rel="noopener noreferrer"><StyledParagraph>Uniswap</StyledParagraph></a>
              <a href={dexScreenerLink} target="_blank" rel="noopener noreferrer"><StyledParagraph>Dexscreener</StyledParagraph></a>
               <a href={CoinMarketCap} target="_blank" rel="noopener noreferrer"><StyledParagraph>CoinMarketCap</StyledParagraph></a>
               <a href={Coingecko} target="_blank" rel="noopener noreferrer"><MainParagraph>Coingecko</MainParagraph></a>
              </Grid>
            </Secdiv>
            <Thirddiv style={{display:'flex',justifyContent:'space-between'}}>
                <div style={{display:'flex',gap:'10px',justifyContent:'center',alignItems:'center'}}>
               <a href='https://t.me/AICMSTORE' target='blank'><img src={tgfooter} alt='footer' draggable='false'/></a>
               <a href='https://x.com/AICMSTORE' target='blank'> <img src={xfooter} alt='footer' draggable='false'/></a>
                </div>
                <Innerdiv style={{display:'flex',gap:'30px', justifyContent:'center',alignItems:'center'}} >
                   <a href={PrivacyPolicy} target="_blank" rel="noopener noreferrer"><Paragraph style={{opacity: '0.6'}}>Privacy Policy</Paragraph></a>
                    <a href={TermsofUse}  target="_blank" rel="noopener noreferrer"><Paragraph style={{opacity: '0.6'}}>Terms of Use</Paragraph> </a>
                </Innerdiv>
                <div style={{display:'flex', justifyContent:'center',alignItems:'center'}}>
                <Paragraph>Copyright © 2025 AICM</Paragraph>
                </div>

            </Thirddiv>
          </Grid>
        </Grid>
      </Container>
    </Wrapper>
  );
};

export default Footer;